import _ from 'lodash';

// todo refactor this, its confusing
export default function (caseProperties) {
  const casePropertiesParsed = {};

  if (!_.isEmpty(caseProperties)) {
    const c = Array.isArray(caseProperties)
      ? caseProperties
      : caseProperties.split(',');

    c.forEach((caseProperty) => {
      casePropertiesParsed[caseProperty] = 1;
    });
    return casePropertiesParsed;
  }
  return null;
}



/** WEBPACK FOOTER **
 ** ./src/utils/casePropertiesParse.js
 **/